import { inject, Service } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { WindowService } from './window.service'
export const DEFAULT_LANGUAGE = 'da'

const SITE_ORIGIN_BY_LANGUAGE: Record<string, string> = {
  da: 'https://gravidmeddiabetes.dk',
  sv: 'https://gravidmeddiabetes.se',
}
const DEFAULT_SITE_ORIGIN = 'https://pregnantwithdiabetes.com'

@Service()
export class LanguageService {
  private translate = inject(TranslateService)
  private windowService = inject(WindowService)

  siteOrigin(): string {
    return SITE_ORIGIN_BY_LANGUAGE[this.translate.getCurrentLang() ?? ''] ?? DEFAULT_SITE_ORIGIN
  }

  // Hosts are the inverse of SITE_ORIGIN_BY_LANGUAGE above; 'au' has no domain of its own.
  getSystemLanguage() {
    const window = this.windowService.nativeWindow()
    switch (window?.location?.host) {
      case 'pregnantwithdiabetes.com':
        return 'en'
      case 'gravidmeddiabetes.dk':
        return 'da'
      case 'gravidmeddiabetes.se':
        return 'sv'
    }

    const browserCultureLang = this.translate.getBrowserCultureLang()
    if (browserCultureLang?.toLocaleLowerCase().match(/au/)) {
      return 'au'
    }
    const browserLang = this.translate.getBrowserLang()
    return browserLang?.toLocaleLowerCase().match(/en|da|sv/) ? browserLang : DEFAULT_LANGUAGE
  }
}
